module.exports = {"mobile_number":"Mobile number","enter_mobile_number":"Enter mobile number","enter_code_and_number":"Enter your country code and mobile number","invalid":"The number you’ve entered doesn’t look like a correct mobile phone number","invalid_no_code":"The number you've entered doesn't look like a correct mobile phone number from {{ country }}","phoneCountry":{"hint_title":"Not a number from {{ country }}?","hint_change_action":"Change country code","selector_title":"Select your country code"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/phone.json
// module id = 651
// module chunks = 247 1440